import { render, staticRenderFns } from "./AdminExports.vue?vue&type=template&id=af831b28&"
import script from "./AdminExports.vue?vue&type=script&lang=js&"
export * from "./AdminExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports